import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "./components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./components/ui/dialog";
import { Users } from "lucide-react";
import { toast } from "sonner";

const ChurchUserManagement = () => {
  const { API, token } = useAuth();
  const [isCreateUserOpen, setIsCreateUserOpen] = useState(false);
  const [newUser, setNewUser] = useState({ username: '', password: '', full_name: '', email: '', role: 'user' });

  const handleCreateUser = async () => {
    if (!newUser.username || !newUser.password) { toast.error('يرجى ملء اسم المستخدم وكلمة المرور'); return; }
    if (newUser.password.length < 6) { toast.error('كلمة المرور يجب أن تكون 6 أحرف على الأقل'); return; }
    try {
      await axios.post(`${API}/api/users/create`, newUser, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('تم إنشاء المستخدم بنجاح');
      setIsCreateUserOpen(false);
      setNewUser({ username: '', password: '', full_name: '', email: '', role: 'user' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'خطأ في إنشاء المستخدم');
    }
  };

  return (
    <Card className="shadow-lg border-green-200">
      <CardHeader className="bg-green-100">
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-green-900"><Users className="w-5 h-5" />إضافة مستخدم جديد للكنيسة</div>
          <Button onClick={() => setIsCreateUserOpen(true)} className="bg-green-600 hover:bg-green-700" size="sm">+ إضافة مستخدم</Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <p className="text-gray-600 text-sm text-center">يمكنك إضافة مستخدمين جدد للكنيسة من هنا</p>
        <Dialog open={isCreateUserOpen} onOpenChange={setIsCreateUserOpen}>
          <DialogContent>
            <DialogHeader><DialogTitle>إضافة مستخدم جديد</DialogTitle></DialogHeader>
            <div className="space-y-4">
              <div><label className="block text-sm font-medium mb-2">اسم المستخدم *</label><Input value={newUser.username} onChange={(e) => setNewUser({...newUser, username: e.target.value})} placeholder="اسم المستخدم" /></div>
              <div><label className="block text-sm font-medium mb-2">كلمة المرور *</label><Input type="password" value={newUser.password} onChange={(e) => setNewUser({...newUser, password: e.target.value})} placeholder="كلمة المرور (6 أحرف على الأقل)" /></div>
              <div><label className="block text-sm font-medium mb-2">الاسم الكامل</label><Input value={newUser.full_name} onChange={(e) => setNewUser({...newUser, full_name: e.target.value})} placeholder="الاسم الكامل" /></div>
              <div><label className="block text-sm font-medium mb-2">البريد الإلكتروني</label><Input type="email" value={newUser.email} onChange={(e) => setNewUser({...newUser, email: e.target.value})} placeholder="البريد الإلكتروني" /></div>
              <div className="flex gap-2">
                <Button onClick={handleCreateUser} className="flex-1 bg-green-600 hover:bg-green-700">إضافة</Button>
                <Button onClick={() => setIsCreateUserOpen(false)} variant="outline" className="flex-1">إلغاء</Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default ChurchUserManagement;
